import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: '100%',
    boxShadow: 'none',
    maxWidth: '420px',
    transition: 'max-width 0.25s ease'
  },
  rootExpanded: {
    maxWidth: '900px'
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: theme.spacing(2),
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    borderRadius: '16px',
    padding: '12px'
  },
  cardMain: {
    flex: '1 1 auto',
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column'
  },
  qrSidePanel: {
    position: 'relative',
    flex: '0 0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    minWidth: '380px',
    maxWidth: '380px',
    padding: '8px 8px 8px 16px',
    textAlign: 'center',
    borderLeft:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main
  },
  qrOverlayFrame: {
    padding: '10px',
    backgroundColor: theme.palette.white_100.main
  },
  qrOverlayCloseButton: {
    position: 'absolute',
    top: -4,
    right: -4,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  qrOverlayWaiting: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  qrOverlayInfo: {
    fontSize: '0.75rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: '1rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  status: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  switchContainer: {
    display: 'flex',
    alignItems: 'end',
    gap: 8,
    marginBottom: 10
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    borderTop:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid ' + theme.palette.gray_stroke.main,
    padding: '4px 0 0 0',
    margin: '4px 0 0 0'
  },
  buttonsAction: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    margin: '8px 0 0 0'
  },
  boxStatus: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  customTableCell: { display: 'flex', alignItems: 'center' },
  statusDefault: {
    color: theme.palette.green_200.main
  },
  statusButton: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  buttonNewQrCode: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    color: theme.palette.white_100.main,
    backgroundColor: theme.palette.blue_300.main,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: theme.palette.green_200.main,
      boxShadow: 'none'
    },

    '& .MuiButton-label': {
      display: 'flex',
      gap: 8
    }
  },
  buttonActionEdit: {
    color: '#007bff'
  },
  buttonActionDelete: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    color: theme.palette.red_100.main
  },
  buttonActionPrivacy: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  statusConnected: {
    color: theme.palette.green_200.main
  },
  statusDisconnected: {
    color: theme.palette.red_100.main
  },
  statusTimeout: {
    color: theme.palette.yellow_400.main
  },
  statusWaiting: {
    color: theme.palette.blue_300.main
  },
  statusQrcode: {
    color: '#007bff'
  },
  statusPasskey: {
    color: theme.palette.purple ? theme.palette.purple.main : '#9c27b0'
  },
  iconButtonActions: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    color: theme.palette.blue_300.main
  },

  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  statusNotDefault: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    backgroundColor: 'transparent',
    '&:hover': {
      color: theme.palette.green_200.main,
      backgroundColor: 'transparent'
    }
  },
  iconButtonLocked: {
    backgroundColor: 'transparent',
    color: theme.palette.blue_300.main,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
}))
